import { render, staticRenderFns } from "./GroupsComponent.vue?vue&type=template&id=6311fdbb&scoped=true"
import script from "./GroupsComponent.vue?vue&type=script&lang=js"
export * from "./GroupsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6311fdbb",
  null
  
)

export default component.exports